






































  import {Component, Vue} from "vue-property-decorator";
  import Navigator from "@/components/Navigator.vue";
  import {AuthService, User} from "@/services/auth.service";
  import {AuthEventBus, AuthEvents} from "@/events";

  @Component({
  name: 'App',
  components: {
    Navigator
  }
})
export default class App extends Vue {

  private auth!: AuthService;

  private initialized = false;
  private user: User | null = null;

  private async getSelf() {
    const res = await this.auth.self();
    if (res.success) this.user = res.result;
  }

  private async mounted() {
    this.auth = new AuthService();
    await this.getSelf();
    this.initialized = true;

    AuthEventBus.on(AuthEvents.Login, async () => {
      await this.getSelf();
    })

    AuthEventBus.on(AuthEvents.Logout, async () => {
      this.user = null;
    })
  }

  private async logout() {
    await this.auth.logout();
  }
}

